import React from "react";
import CustomerSelect from '../Selects/CustomerSelect';
import UserSelect from '../Selects/UserSelect';
import DateHelper from "../DateHelper/DateHelper";
import DatePickerInput from '../DatePickerInput/DatePickerInput';
import TimePickerInput from '../TimePickerInput/TimePickerInput';
import NumberSpinner from "../NumberSpinner/NumberSpinner";
import clsx from "clsx";
import Select2MultiSelect from "../Selects/Select2MultiSelect";

class DataTableSearch extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      searchValues: {},
      searchOpen: false,
      room: null,
      user: null,
      customer: null,
      lastChanged: null
    }
    this.renderFilters = this.renderFilters.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onMultiSelectChange = this.onMultiSelectChange.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.onClickX = this.onClickX.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeTime = this.onChangeTime.bind(this);
    this.onChangeInteger = this.onChangeInteger.bind(this);
    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.setState({searchValues: this.props.searchValues})
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchValues.general && this.props.searchValues.general !== prevProps.searchValues.general) {
      this.setState({searchValues: this.props.searchValues})
    }
  }

  componentWillUnmount(){
    $(window).off('click')
  }

  render() {
    var self = this
    var search_value = self.state.searchValues.general || ""
    var tabClasses = clsx({
      'open-search-box': this.state.searchOpen,
      'searchBox': true,
      'active-search': search_value != "" && !this.state.searchOpen,
    })

    return (
      <div className="search-container filter">
        <div className={tabClasses} onSubmit={(e) => self.submit(e)}>
          {
            this.state.searchOpen && ($(window).width() > 767)
            ?
            <div className="container p-0">
              <input type="text" name="general" className="form-control data-search-input col-10 border-0" placeholder={I18n.t('search')} onChange={this.onChangeSearch} value={search_value}></input>
              <span className="close-search" onClick={self.onClickX} aria-label="Close Account Info Modal Box">&times;</span>
            </div>
            :
            null
          }
          <button className="mg" onClick={self.state.searchOpen ? (e) => self.submit(e) : this.openSearch}>
          {
            search_value == ""
            ?
            <i className="ss-search search-icon"></i>
            :
            <i className="ss-zoomin search-icon active-search"></i>
          }
          </button>
          {
            this.state.searchOpen && ($(window).width() <= 767)
              ?
              <input type="text" name="general" className="form-control data-search-input" placeholder={I18n.t('search')} onChange={this.onChangeSearch} value={search_value}></input>
              :
              null
          }
          {
            this.state.searchOpen
            ?
            <div className="filter-wrapper">
            {this.renderFilters()}
            <div className="filter-buttons">
              <button type="button" className="no-ladda btn btn-secondary" onClick={self.cancel}>{I18n.t('cancel')}</button>
              <button type="button" className="no-ladda btn btn-primary search" onClick={self.submit}>{I18n.t('search')}</button>
            </div>
          </div>
          :
          null
        }
        </div>
      </div>
    )
  }

  renderFilters() {
    var self = this;

    return (
      <form className="filter-container filter" >
        <ul className="filter-list">
          {self.props.headers.map((header, idx) => {
            var header_name = header.display_name || header.column_name
            var search_value = undefined
            var select_value = undefined

            if (header.search_type === "String" || header.search_type === "TranslatedString") {
              if (header.options) {
                var options = header.options.map((option, idx) => {
                    if (header.search_type === "TranslatedString") {
                      return {value: option, id: option, name: I18n.t(option)}
                    } else {
                      return {value: option, name: option}
                    }
                })

                var values = self.state.searchValues[header.column_name] || search_value

                if (values) {
                  if (typeof values == "object" && values[0] != undefined) {
                    if (values[0].includes(",")){
                      values = values[0].split(",")
                    }

                    values = values.map((val) => {
                      return {name: val, id: val}
                    })
                  } else {
                    if (values.includes(",")){
                      values = values.split(",")

                      values = values.map((val) => {
                        return {name: val, id: val}
                      })
                    } else {
                      values = [{name: values, id: values}]
                    }
                  }
                } else {
                  values = []
                }

                return (
                  <li key={idx} className="filter-item">
                    <label className="filter-head">{I18n.t(header_name)}</label>
                    <hr/>
                    <div className="filter">
                      <Select2MultiSelect
                        values={values}
                        name={header.column_name}
                        onChange={self.onMultiSelectChange}
                        className="form-control filter-select-input col-xs-9 col-sm-9 col-md-9"
                        options={options} />
                    </div>
                  </li>
                )
              } else {
                return <li key={idx} className="filter-item"><label className="filter-head">{I18n.t(header_name)}</label><hr/><input className="form-control filter-text-input col-xs-9 col-sm-9 col-md-9" type="text" name={header.column_name} defaultValue={self.state.searchValues[header.column_name] || search_value} onChange={self.onFilterChange}></input></li>
              }
            } else if (header.search_type == "Date") {
              if (self.state.searchValues[`${header.column_name}_from`]) {
                var start_date_value = typeof self.state.searchValues[`${header.column_name}_from`] == 'string' ? DateHelper.parseDateFromBackend(self.state.searchValues[`${header.column_name}_from`]) : new Date(self.state.searchValues[`${header.column_name}_from`]);
              }

              if (self.state.searchValues[`${header.column_name}_to`]) {
                var end_date_value = typeof self.state.searchValues[`${header.column_name}_to`] == 'string' ? DateHelper.parseDateFromBackend(self.state.searchValues[`${header.column_name}_to`]) : new Date(self.state.searchValues[`${header.column_name}_to`]);
              }

              return(
              <li key={idx} className="filter-item">
                <label className="filter-head">{I18n.t(header_name)}</label>
                <hr/>
                <div className="filter-date-container col-xs-9 col-sm-9 col-md-9">
                  <div className="filter-date-input">

                    <label className="filter-sub-head">{`${I18n.t('from')}`}</label>

                    <DatePickerInput
                      classNames="filter"
                      name={`${header.column_name}_from`}
                      minDate={new Date(2020, 0, 1)}
                      selectedDate={start_date_value || ''}
                      dateFormat={DateHelper.rubyToDateFNS(self.props.date_format)}
                      customChangeHandler={self.onChangeDate}
                      customChangesource="DatatableSearch"/>
                  </div>

                  <div className="filter-date-input">
                    <label className="filter-sub-head">{`${I18n.t('to')}`}</label>

                    <DatePickerInput
                      classNames="filter"
                      name={`${header.column_name}_to`}
                      minDate={new Date(2020, 0, 1)}
                      selectedDate={end_date_value || ''}
                      dateFormat={DateHelper.rubyToDateFNS(self.props.date_format)}
                      customChangeHandler={self.onChangeDate}
                      customChangesource="DatatableSearch"/>
                  </div>
                </div>
              </li>
              )
            } else if (header.search_type == "Time") {
              if (self.state.searchValues[`${header.column_name}_from`]) {
                var start_time_value = self.state.searchValues[`${header.column_name}_from`]
              }

              if (self.state.searchValues[`${header.column_name}_to`]) {
                var end_time_value = self.state.searchValues[`${header.column_name}_to`]
              }
              return (
                <li key={idx} className="filter-item">
                  <label className="filter-head">{I18n.t(header_name)}</label>
                  <hr/>
                  <div className="filter-date-container col-xs-9 col-sm-9 col-md-9">
                    <div className="filter-date-input">
                      <label className="filter-sub-head">{`${I18n.t('from')}`}</label>
                      <TimePickerInput name={`${header.column_name}_from`} selectedTime={start_time_value || ''} classNames="filter" format={this.props.time_format} customChangeHandler={self.onChangeTime} customChangesource="DatatableSearch"/>
                    </div>

                    <div className="filter-date-input">
                      <label className="filter-sub-head">{`${I18n.t('to')}`}</label>
                      <TimePickerInput name={`${header.column_name}_to`} selectedTime={end_time_value} classNames="filter" format={this.props.time_format} customChangeHandler={self.onChangeTime} customChangesource="DatatableSearch"/>
                    </div>
                  </div>
                </li>
              )
            } else if (header.search_type == "Integer") {
              Object.keys(self.state.searchValues).forEach(function (key) {
                if (key.split(/_less|_greater|_equal/)[0] == header.column_name.split("_select")[0]) {
                  var splitHeader = key.split(header.column_name + "_")
                  select_value = splitHeader[1]
                  search_value = self.state.searchValues[key]
                }
              })
              return (
                <li key={idx} className="filter-item">
                  <label className="filter-head">{I18n.t(header_name)}</label>
                  <hr/>
                  <div className="filter-integer-container row col-xs-12">
                    <div className="filter-quantity-select col-xs-5 col-sm-5 col-md-5">
                      <select
                        value={select_value}
                        onChange={(e) => self.clickSpinner(e)}
                        id={header.column_name + "_select"}
                        className="form-control">
                        <option value="less_than">{I18n.t('less_than')}</option>
                        <option value="less_than_or_equal_to">{I18n.t('less_than_or_equal_to')}</option>
                        <option value="equal_to">{I18n.t('equal_to')}</option>
                        <option value="greater_than_or_equal_to">{I18n.t('greater_than_or_equal_to')}</option>
                        <option value="greater_than">{I18n.t('greater_than')}</option>
                      </select>
                    </div>

                    <div className="filter-quantity-spinner col-xs-7 col-sm-7 col-md-7">
                      <NumberSpinner onChange={(e) => self.onChangeInteger(e, header.column_name)} id={header.column_name + "_spinner"} name={header.column_name} className="filter form-control" max={999999} min= {-999999} data_decimals={header.data_type == "Currency" ? "2" : header.decimals ? header.decimals : 0} step={header.step ? header.step : 1} value={search_value}/>
                    </div>
                  </div>
                </li>
              )
            } else if (header.search_type == "Boolean") {
              return (
                <li key={idx} className="filter-item">
                  <label className="filter-head">{I18n.t(header_name)}</label>
                  <hr/>
                  <div className="filter">
                    <select
                      defaultValue={self.state.searchValues[header.column_name] || search_value}
                      name={header.column_name}
                      onChange={self.onFilterChange}
                      className="form-control filter-select-input col-xs-9 col-sm-9 col-md-9">
                      <option value="any">{I18n.t('any')}</option>
                      <option value="yes">{I18n.t('yes')}</option>
                      <option value="no">{I18n.t('no')}</option>
                    </select>
                  </div>
                </li>
              )
            } else if (header.search_type == "User") {
              return (
                <li key={idx} className="filter-item">
                  <label className="filter-head">{I18n.t(header_name)}</label>
                  <hr/>
                  <div className="filter">
                    <UserSelect
                      onChange={self.onFilterChange}
                      className='filter-select-input col-xs-9 col-sm-9 col-md-9'
                      name={header.column_name}
                      user={self.state.user || self.state.searchValues[header.column_name]}
                    />
                  </div>
                </li>
              )
            } else if (header.search_type == "Customer") {
              return (
                <li key={idx} className="filter-item">
                  <label className="filter-head col-xs-3 col-sm-3 col-md-3" style={{ padding: 0 }}>{I18n.t(header_name)}</label>
                  <hr/>
                  <div className="filter-select-input col-xs-9 col-sm-9 col-md-9" style={{ padding: 0 }}>
                    <CustomerSelect
                      onChange={self.onFilterChange}
                      name={header.column_name}
                      customer={self.state.customer || self.state.searchValues[header.column_name]}
                      allowClear={true}
                    />
                  </div>
                </li>
              )
            }
          })}
        </ul>
      </form>
    )
  }

  openSearch = () => this.setState({ searchOpen: !this.state.searchOpen })

  onChangeDate(date, header){
    var searchValues = {...this.state.searchValues}
    
    if(date){
      searchValues[header] = date
    } else {
      searchValues[header] = null
    }
    this.setState({searchValues: searchValues, lastChanged: "filter"})
  }

  onChangeTime(time, header){
    var searchValues = {...this.state.searchValues}
    searchValues[header] = time
    this.setState({searchValues: searchValues, lastChanged: "filter"})
  }

  onChangeInteger(event, header){
    var sub_header = $(`#${header}_select`)[0].value ? $(`#${header}_select`)[0].value : "less_than"
    var searchValues = { ...this.state.searchValues }

    Object.keys(searchValues).forEach(function (key) {
      if(key.split(/_less|_greater|_equal/)[0] == event.target.name) {
        delete searchValues[key];
      }
    });
    searchValues[event.target.name + '_' + sub_header] = event.target.value
    this.setState({searchValues: searchValues, lastChanged: "filter"})
  }

  clickSpinner(e) {
    var searchValues = {...this.state.searchValues}
    var header = e.target.id
    var integerValue = 0
    Object.keys(searchValues).forEach(function (key) {
      if (key.split(/_less|_greater|_equal/)[0] == header.split("_select")[0]) {
        integerValue = searchValues[key]
        delete searchValues[key];
      }
    })

    searchValues[header.split("_select")[0] + "_" + e.target.value] = integerValue
    this.setState({searchValues: searchValues, lastChanged: "filter"})
  }

  onChangeSearch(e) {
    var searchValues = { ...this.state.searchValues }
    searchValues.general = e.target.value
    this.setState({searchValues: searchValues, lastChanged: "general"})
  }

  onClickX() {
    var searchValues = {general: ""}
    if (document.getElementsByTagName) {
      var inputs = document.querySelectorAll('input')
      for(var i = 0, ilen = inputs.length; i < ilen; i++) {
        if (inputs[i].className.includes("filter")) {
          inputs[i].value = ""
        }
      }

      var selects = document.querySelectorAll('select')
      for(var i = 0, ilen = selects.length; i < ilen; i++) {
        if (selects[i].className.includes("filter")) {
          selects[i].value = "any"
        }
      }
    }
    this.openSearch()
    this.setState({searchValues: searchValues, room: "", user: "", customer: ""})
    this.props.changeSearchValues(searchValues, true)
  }

  onFilterChange(event) {
    var searchValues = { ...this.state.searchValues }
    var room = this.state.room
    var user = this.state.user
    var customer = this.state.customer

    if (event.target) {
      searchValues[event.target.name] = event.target.value
    } else if ("identifier" in event) {
      if (event.identifier == null) {
        delete searchValues[event.header]
        searchValues["general"] = ''
        room = ""
      } else {
        searchValues[event.header] = event.identifier
        room = event
      }
    } else if ("full_name" in event) {
      if (event.full_name == null) {
        delete searchValues[event.header]
        searchValues["general"] = ''
        customer = ""
      } else {
        searchValues[event.header] = event.full_name
        customer = event
      }
    } else if (!event.text) {
      if (event.name == null) {
        delete searchValues[event.header]
        searchValues["general"] = ''
        user = ""
      } else {
        searchValues[event.header] = event.name
        user = event
      }
    }
    this.setState({searchValues: searchValues, room: room, user: user, customer: customer, lastChanged: "filter"})
  }

  onMultiSelectChange(event, name) {
    var searchValues = { ...this.state.searchValues }
    searchValues[name] = []
    
    event.map(e => {
      searchValues[name].push(e.id)
    })

    this.setState({searchValues: searchValues, lastChanged: "filter"})
  }

  cancel() {
    this.openSearch()
  }

  submit(event) {
    event.preventDefault()
    var searchValues = {...this.state.searchValues}
    
    if (this.state.lastChanged == "general") {
      var general = true
      searchValues = {
        general: searchValues["general"]
      }
    }
    
    this.openSearch()
    this.props.changeSearchValues(searchValues, true, general)
  }
};

export default DataTableSearch
